import { Client } from "@api/index";
import { Loader } from "@pw-tech/omni-ui";
import cohortSDK from "@utils/cohort.sdk";
import { AUTH_SDK_ID } from "@utils/constants";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";


function CohortSelection() {
    const [isLoading, setIsLoading] = useState(true);
    const hasInitialized = useRef(false);

    const navigate = useNavigate();
    const location = useLocation();

    const getCohortDetails = async (route: string, selectedExamClass: any) => {
        const response: any = await Client.post(
            `${process.env.REACT_APP_PP_API_BASE_URL}v1/student-acquisition/ambassador-client/cohort-detail`,
            selectedExamClass,
        )
        const cohortId = response?.data?.data?._id

        if (cohortId) {
            localStorage?.setItem("COHORT_DETAILS", JSON.stringify(response?.data?.data))
            localStorage?.setItem("COHORT_ID", cohortId)
            // localStorage?.setItem("FILTER_TAGS", JSON.stringify(response?.data?.data?.filterTags))
            // localStorage?.setItem("FILTERS", JSON.stringify(testdata || response?.data?.data?.filters))
            // localStorage?.setItem("FILTERS", JSON.stringify(testdata))
            navigate(route + `?cohortId=${cohortId}`)
        } else {
            toast.error("Cohort is not available")
        }
    }

    useEffect(() => {
        const previousUrl = location.state?.prevUrl;
        if (!hasInitialized.current) {
            setTimeout(() => {
                cohortSDK({
                    goBack: () => navigate(-1),
                    handleRelativeRedirection: (route: string, selectedExamClass: any) => {
                        getCohortDetails(route, selectedExamClass)
                    },
                    previousUrl,
                    redirectUrl: "/sales/batch-listing",
                });
            }, 1000)
            hasInitialized.current = true;
        }

        const checkContent = () => {
            const authFlowElement = document.getElementById(AUTH_SDK_ID);
            if (authFlowElement && authFlowElement.children.length > 0) {
                setIsLoading(false);
            }
        };

        const observer = new MutationObserver(checkContent);
        const targetNode = document.getElementById(AUTH_SDK_ID);
        if (targetNode) {
            observer.observe(targetNode, { childList: true });
        }

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div id={AUTH_SDK_ID} />
            {
                isLoading && (
                    <div className="flex h-full min-h-screen items-center justify-center">
                        <Loader
                            color="primary"
                            size={'medium'}
                            message="Please wait..."
                        />
                    </div>
                )
            }
        </>
    );
}

export default CohortSelection;
